// Remembers exported files (blob downloads / direct export URLs) so they can be re-sent via WhatsApp.
const blobs = new Map();
const EXPORT_RE = /\.(xlsx|xls|csv|pdf|docx?|png|jpe?g|zip)$/i;
let last = 0;

const emit = (a) => {
  const name = a.getAttribute("download") || "";
  const href = a.href || "";
  if (!EXPORT_RE.test(name) && !/export|excel|\.xlsx|merged\.pdf|documents\.zip/i.test(href)) return;
  if (Date.now() - last < 800) return;
  last = Date.now();
  const blob = href.startsWith("blob:") ? blobs.get(href) : null;
  if (href.startsWith("blob:") && !blob) return;
  let filename = name || decodeURIComponent(href.split("?")[0].split("/").pop() || "file");
  if (!/\.[a-z0-9]{2,4}$/i.test(filename)) filename += blob?.type?.includes("pdf") ? ".pdf" : ".xlsx";
  window.dispatchEvent(new CustomEvent("wz-export", { detail: { blob, url: blob ? null : href, filename } }));
};

if (typeof window !== "undefined" && !window.__exportCapture) {
  window.__exportCapture = true;
  const create = URL.createObjectURL.bind(URL);
  URL.createObjectURL = (obj) => {
    const u = create(obj);
    if (obj instanceof Blob) { blobs.set(u, obj); setTimeout(() => blobs.delete(u), 180000); }
    return u;
  };
  const aClick = HTMLAnchorElement.prototype.click;
  HTMLAnchorElement.prototype.click = function capturedClick(...args) {
    const r = aClick.apply(this, args);
    if (this.hasAttribute("download")) emit(this);
    return r;
  };
  const aDispatch = HTMLAnchorElement.prototype.dispatchEvent;
  HTMLAnchorElement.prototype.dispatchEvent = function capturedDispatch(ev) {
    const r = aDispatch.call(this, ev);
    if (r !== false && ev?.type === "click" && this.hasAttribute("download") && !this.isConnected) emit(this);
    return r;
  };
  document.addEventListener("click", (e) => {
    const a = e.target.closest?.("a[href]");
    if (a && !e.defaultPrevented && (a.hasAttribute("download") || /\/api\/.*(export|excel|\.xlsx)/i.test(a.href))) emit(a);
  });
}
